export default __webpack_public_path__ + "static/media/GH.87df1b86.svg";